// CvoLogin.js
import React, {useState, useEffect} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { TextField, Button, IconButton, Popover } from '@mui/material';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Waiting } from '../message/Waiting';
import { LOG_IN } from './SessionGql';
import {useLazyQuery} from '@apollo/client';
import {logRepo, userInfoRepo} from '../../model/CvoModel';
import { CvoMsg, ErrorMsg, AppObject, AppWord, AppPalette } from '../../model/AppConst';
import NotifyBoard from '../notify_board/NotifyBoard';
import UserSessionInfo from '../common/UserSessionInfo';
import Util from '../../model/Util';
import useClientSize from '../hook/useClientSize';
import LogInLogo from './etrace_login_logo.svg';

const MinBoardHeight = 460;

const OuterLoginContainer = styled(Box)({
    width: '100%',
    textAlign:'center',
    verticalAlign:'bottom',
    paddingTop:30,
});

const InnerContainer = styled(Box)({ display:'inline-flex', flexDirection:'column', verticalAlign:'bottom', minWidth:1120 });

const BottomBar = styled(Box)({
    display:'block',
    color:'#333333',
    backgroundColor:'#dbdbea',
    padding:'5px 10px',
    fontSize:'small',
    borderRadius:30,
    border:'1px solid #9595a0',
    marginTop:10,
});
// In InnerContainer, above BottomBar. CONTAINS LeftBox + MainBox
const ControlContainer = styled(Box)({ flexGrow:1, display:'flex' });

const LeftBox = styled(Box)({ width:300, paddingRight: 10, paddingBottom:10, display:'flex', flexDirection:'column'});
const UpperFiller = styled(Box)({flexGrow:1});
// 공지사항
const MainBox = styled(Box)({
    flexGrow: 1,
    minHeight: MinBoardHeight,
    textAlign:'left',
    display:'flex', flexDirection:'column'
});

const MainTitle = styled(Box)({
    padding:10, fontWeight:'bold', backgroundColor: AppPalette.HeaderBackground, color:'white',
    borderRadius:20, textAlign:'center'
});
const BoardBox = styled(Box)({
    flexGrow:1,
    padding: 5,
    position:'relative',
});

const SmallTitle = styled(Box)({
    backgroundColor:'#1c1c60',
    border: '1px solid #1c1c60',
    color:'#fff',
    fontWeight:'bold',
    textAlign:'center',
    width: '100%',
    marginTop: 5, marginBottom: 5,
    paddingTop: 10, paddingBottom: 10,
    borderRadius: 20
});

// ######################
const InfoTable = styled(Box)({
    display:'table',
    border: '1px solid #cccccc',
    width: '100%',
    borderRadius: 5
});
const TableRow = styled(Box)({display:'table-row'});
const TableTitleCell = styled(Box)({display:'table-cell', textAlign:'center', paddingTop: 10, paddingBottom: 10, fontSize:'0.9em', color:'#333'});
const TableCell = styled(Box)({display:'table-cell', textAlign:'left', paddingTop: 10, paddingBottom: 10, fontWeight:'bold',});

// ######################
const MessageBox = styled(Box)({
    marginTop:10,
    padding:10,
    border:'1px solid #ccc',
    borderRadius:10,
    textAlign: 'left',
});

const MessageLine = styled(Box)({
    marginTop:5, fontSize:'0.9em', padding: 2, display: 'flex', alignItems: 'center',
    borderBottom: '1px dotted #ccc'
});
const MessageText = styled(Box)({flexGrow:1,});


export default function CvoLogin({
    onForgotPassword,
}) {
    const [logInNow, {loading, error, data}]
        = useLazyQuery(LOG_IN, AppObject.NoCachedFetch);
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    // const [showTestUsers, setShowTestUsers] = useState(false);
    const [loginError, setLoginError] = useState(undefined);
    const [anchor1stEl, setAnchor1stEl] = useState(null);
    const [anchorForgotEl, setAnchorForgotEl] = useState(null);
    const clientSize = useClientSize();

    useEffect(() => {
        const id = localStorage.getItem(AppWord.LOCAL_ID_KEY);
        if(id) setUserId(id);
    }, []);

    useEffect(() => {
        if(data && data.login) {
            if(data.login.user.msg===CvoMsg.OK) {
                setLoginError(undefined);
                // userInfoRepo({...data.login, signedIn: true, sessionChecked: true});
                const sInfo = new UserSessionInfo(true, true, data.login);
                sInfo.checkIfNeedToChangePassword(password);
                userInfoRepo(sInfo);
                localStorage.setItem(AppWord.LOCAL_ID_KEY, userId);
                setPassword(null);
                Util.bubbleSnack("이트레이스 차량관제입니다. 반갑습니다.");
            }
            else
                setLoginError(
                    data.login.user.msg===ErrorMsg.AUTH_ERROR 
                    ? '아이디/암호가 맞는지 확인해 주세요' : data.login.user.msg);
        }
    }, [data, userId]);

    //const IsDevVSCode = window.location.href.startsWith("http://localhost");
    //const IsDevLocal = window.location.href.startsWith("http://");

    const onClickSignIn = (e) => {
        logRepo([]);
        logInNow({variables:{userId:userId, password:password}});
    };

    const onChangePassword = (e) => {
        /* if(e.target.value==='showmethemoney') {
            setShowTestUsers(true);
        } */
        setPassword(e.target.value);
    };

    /* const onClickTestUser = (id) => {
        setUserId(id);
        setPassword(id==='etracedev' ? 'tldus25' : 'tldus,fk5');
        // setShowTestUsers(false);
    }; */

    if(loading) return <Waiting message="로그인 중입니다." />;
    if(error) return <Box>Something went wrong in signing in</Box>

    let BoardHeight = clientSize.height - 130;
    if(BoardHeight < MinBoardHeight) BoardHeight = MinBoardHeight;

    const renderMsgFirstLogin = () => {
        return (
            <MessageLine>
                <MessageText>신규사이트 로그인을 처음 하신다면..</MessageText>
                <IconButton
                    size='small'
                    onClick={(e) => setAnchor1stEl(e.currentTarget)}
                    color='primary'
                >
                    <NotListedLocationIcon />
                </IconButton>
                <Popover
                    open={Boolean(anchor1stEl)}
                    anchorEl={anchor1stEl}
                    onClose={() => setAnchor1stEl(null)}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Box style={{padding: 10, maxWidth: 400}}>
                        <p>새로운 차량관제 사이트에 오신 것을 환영합니다.</p>
                        <p>새로운 사이트로의 이전작업은 업체별로 하나씩 진행됩니다.
                            그 과정에서 별도의 안내를 차량관제 담당자님께 드리는데,
                            만일, 그 안내에 대한 내용을 모르신다면, 먼저 귀사의 차량관제 담당자님께 문의해 주세요.
                        </p>
                        <p>안내를 받으셨다면, 로그인을 위해 일괄로 설정된 암호가 있다는 것을 아실 것으로 생각합니다.
                            해당 암호를 사용해서 로그인 하신 후에는 즉시 암호를 변경하는 화면으로 넘어가게 됩니다.
                            새 암호를 설정하신 후, 다시 자동 로그아웃되며, 새 암호로 다시 로그인 하시면 됩니다.
                        </p>
                    </Box>
                </Popover>
            </MessageLine>
        );
    };

    const renderMsgForgotPassword = () => {
        return(
            <MessageLine style={{borderBottom: 'none', }}>
                <MessageText>아이디나 암호를 잊으셨나요?</MessageText>
                <IconButton
                    size='small'
                    onClick={(e) => setAnchorForgotEl(e.currentTarget)}
                    color='primary'
                >
                    <NotListedLocationIcon />
                </IconButton>
                <Popover
                    open={Boolean(anchorForgotEl)}
                    anchorEl={anchorForgotEl}
                    onClose={() => setAnchorForgotEl(null)}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Box style={{padding: 10, maxWidth: 400}}>
                        <p>아이디나 암호를 잊으셨다면, 다음 중 한가지를 진행해 주시면 됩니다.</p>
                        <ul>
                            <li>
                                <span>이메일 주소가 등록되어 있다면 메일을 통해서 재설정할 수 있습니다.</span>
                                <Button size='small' onClick={()=>onForgotPassword()}
                                    variant='outlined'
                                    startIcon={<ArrowForwardIcon />}
                                    style={{marginLeft:10}}
                                >진행</Button>
                            </li>
                            <li>차량관제 사이트에 관리자가 아닌 일반사용자로 등록되어 있다면, 관리자로 등록된 귀사의 담당자님께 암호 설정을 요청해 주세요. (기초정보관리 &gt; 사용자 관리)</li>
                            <li>
                                위와 같은 방법이 모두 어렵다면, 이트레이스에 서면으로 요청해 주셔야 합니다. 이트레이스로 연락 주셔서 필요 서류에 대한 안내를 받으시고 진행해 주시기 바랍니다.</li>
                            <li>
                                참고로, 전화만으로는 누구인지 확인이 불가능하기 때문에 처리가 불가능합니다.
                            </li>
                        </ul>
                    </Box>
                </Popover>
            </MessageLine>
        );
    };

    return (
        <OuterLoginContainer>
            <InnerContainer>
                <ControlContainer>
                    <LeftBox>
                        <UpperFiller>&nbsp;</UpperFiller>
                        <Box style={{paddingBottom:20}}>
                            <img src={LogInLogo} alt="eTrace" width={160} />
                        </Box>
                        <Box>
                            <form>
                            {/* <SmallTitle>차량관제 로그인</SmallTitle> */}
                            <TextField id="userId" label="아이디" size='small' fullWidth
                                value={userId}
                                onChange={(e)=>setUserId(e.target.value)}
                                onKeyUp={(e) => {if(e.key==='Enter') { document.getElementById('password').focus();}}}
                                style={{marginBottom:8}}/>
                            <TextField id="password" label="암호" size='small' fullWidth
                                value={password}
                                onChange={onChangePassword}
                                onKeyUp={(e) => {if(e.key==='Enter') onClickSignIn(e)}}
                                type="password"
                                style={{marginBottom:8}} />
                            <Button onClick={onClickSignIn} fullWidth
                                variant='contained'>
                                로그인</Button>
                            </form>
                        </Box>
                        <MessageBox>
                            {
                                loginError
                                ? <MessageLine style={{color: 'red'}}>{loginError}</MessageLine> : null
                            }
                            {renderMsgFirstLogin()}
                            {renderMsgForgotPassword()}
                        </MessageBox>
                        <Box>&nbsp;</Box>
                        <SmallTitle>연락처</SmallTitle>
                        <InfoTable>
                            <TableRow>
                                <TableTitleCell width={80}>대표전화</TableTitleCell>
                                <TableCell>(02)3437-5858</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableTitleCell width={80}>일반전화</TableTitleCell>
                                <TableCell>031-704-5852</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableTitleCell width={80}> </TableTitleCell>
                                <TableCell>031-704-9410~1</TableCell>
                            </TableRow>
                            
                            <TableRow>
                                <TableTitleCell width={80}>팩스</TableTitleCell>
                                <TableCell>031-704-5007</TableCell>
                            </TableRow>
                        </InfoTable>
                    </LeftBox>
                    <MainBox height={BoardHeight}>
                        <MainTitle>이트레이스 차량관제 공지사항</MainTitle>
                        <BoardBox><NotifyBoard /></BoardBox>
                    </MainBox>
                </ControlContainer>
                <BottomBar>
                    (주)이트레이스. (우)13591 경기도 성남시 분당구 황새울로 314, 3층 (서현동, 유니퀘스트빌딩)
                </BottomBar>
            </InnerContainer>
        </OuterLoginContainer>
    );
    // mailetrace0, mailetrace1
    // yjetrace0, yjetrace1
    // tldus,fk5
}

/*

                    {
                        IsDevVSCode || (IsDevLocal && showTestUsers)
                        ?
                        <span>
                            <Button size={AppWord.SMALL} onClick={()=>{onClickTestUser('mailetrace0')}}>mailetrace0</Button>
                            <Button size={AppWord.SMALL} onClick={()=>{onClickTestUser('mailetrace1')}}>mailetrace1</Button>
                            <Button size={AppWord.SMALL} onClick={()=>{onClickTestUser('dwonetrace0')}}>dwonetrace0</Button>
                            <Button size={AppWord.SMALL} onClick={()=>{onClickTestUser('yjetrace0')}}>yjetrace0</Button>
                            <Button size={AppWord.SMALL} onClick={()=>{onClickTestUser('yjetrace1')}}>yjetrace1</Button>
                            <Button size={AppWord.SMALL} onClick={()=>{onClickTestUser('etracedev')}}>etracedev</Button>
                            <Button size={AppWord.SMALL} onClick={()=>{onClickTestUser('logetrace')}}>logetrace</Button>
                            <Button size={AppWord.SMALL} onClick={()=>{onClickTestUser('logetrace1')}}>logetrace1</Button>
                        </span>
                        :
                        null
                    }

*/
